import React from 'react'
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers'
import { ThemeProvider } from '@material-ui/styles'
import DateJsUtils from '@date-io/dayjs'
import nbLang from 'dayjs/locale/nb';
import { datePickerTheme } from '../datePickerStyles'
import { isMobile } from 'react-device-detect'


export const DatePicker = ({
    selectedDate,
    disableDates,
    handleDateChange,
    setSelectedMonthDate,
}) => (
    <ThemeProvider theme={datePickerTheme(selectedDate, isMobile)}>
        <MuiPickersUtilsProvider locale="nb" utils={DateJsUtils}>
            <KeyboardDatePicker
                variant="static"
                format="MM/dd/yyyy"
                value={selectedDate}
                onChange={handleDateChange}
                onMonthChange={setSelectedMonthDate}
                shouldDisableDate={disableDates}
                disableToolbar
                disablePast
            />
        </MuiPickersUtilsProvider>
    </ThemeProvider>
)
